import { addModal } from '@/exceed';
import i18n from 'i18next';

export default () => addModal({
  actions: [
    {
      action: 'cancel',
      element: 'button',
      text: i18n.t('cancel'),
      variant: 'ghost',
    },
    {
      action: 'delete',
      color: 'brand',
      element: 'button',
      text: i18n.t('delete'),
    },
  ],
  body: i18n.t('delete-initiative-body'),
  hasCloseButton: true,
  title: i18n.t('delete-initiative'),
});
